// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"

const registerServiceWorker = async () => {
  if (navigator.serviceWorker) {
    try {
      await navigator.serviceWorker.register('/service-worker.js')
      console.log('Service worker registered!')
    } catch (error) {
      console.error('Error registering service worker: ', error)
    }
  }
}

registerServiceWorker()